// extracted by mini-css-extract-plugin
export default {"workspace_subtitile":"rOkM7C","workspaceSubtitile":"rOkM7C"};